import Amplify from '../amplify';
import CONFIG from '../config';

const handleResponse = (response) => {
  if (!response) {
    return null;
  }
  if (response.Item) {
    return response.Item;
  }
  if (response.Items) {
    return response.Items;
  }
  return response;
};

export default (type, url, params = null, body = null) => {
  const request = {
    headers: {},
  };
  if (params) {
    request.queryStringParameters = params;
  }
  if (body) {
    request.body = body;
  }
  return Amplify.API[type](CONFIG.ALICE_API, `/${url}`, request).then(
    handleResponse,
  );
};
